<template>
  <div class="container">
    <Header></Header>
    <div class="dWrap">
      <div class="content" v-if="newsData">
        <div class="m_title">{{ newsData.title }}</div>
        <!-- <div class="d-title">
          <p>{{ newsData.title }}</p>
          <p v-if="newsData.digest && newsData.digest!=-1">{{ newsData.digest }}</p>
          <p class="author" v-if="newsData.createUser && newsData.createUser!=-1">
            <span>{{ newsData.createUser }}</span>
          </p>
        </div> -->
        <div class="detail">
          <div class="d-content" v-html="newsData.content"></div>
          <div class="fileList">
            <template v-if="newsData && newsData.attachs && newsData.attachs.length > 0">
              <div class="file" v-for="(item, key) in newsData.attachs" :key="key" @click="download(item)">
                <span>{{ key + 1 }}、{{ item.originalName }}</span>
                <el-button type="text" icon="el-icon-download"></el-button>
              </div>
            </template>
          </div>
        </div>
        <div class="ctrl">
          <span @click="close">〖关 闭〗</span>
          <span @click="print">〖打 印〗</span>
        </div>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'home',
  data() {
    return {
      newsData: ''
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.$api(
        this.$config.apiUrl.detail,
        {
          id: this.$route.params.id
        },
        { method: 'get' }
      )
        .then(data => {
          this.newsData = data;
        })
        .catch(e => {
          console.log('失败');
        });
    },
    close() {
      window.close();
    },
    print() {
      window.print();
    },
    //点击下载文件
    download(item) {
      window.open(item.link);
    }
  },
  components: {
    Header,
    Footer
  }
};
</script>

<style lang="less" scoped>
.container {
  min-width: 1198px;
  .dWrap {
    width: 1124px;
    padding: 0 14px;
    margin: 0 auto;
    background: #fff;
    overflow-x: hidden;
  }
  .content {
    padding: 20px 0 70px;
    .m_title {
      position: relative;
      padding: 23px 0;
      text-align: center;
      font-size: 32px;
      color: #000000;
      border-bottom: 1px solid #013f99;
      &:after {
        position: absolute;
        content: '';
        left: 0;
        bottom: 0;
        width: 84px;
        height: 4px;
        background: #013f99;
      }
    }
    .d-title {
      padding: 35px 0 0;
      p {
        line-height: 42px;
        text-align: center;
        font-size: 24px;
        color: #000000;
        &.author {
          font-size: 16px;
          padding: 14px 0 0;
          line-height: 36px;
        }
      }
    }
    /deep/.detail {
      padding: 0 18px;
      overflow: hidden;
      white-space: pre-wrap;
      * {
        max-width: 100%;
        word-break: break-all;
        word-wrap: break-word;
        box-sizing: border-box;
      }
      .d-content {
        padding: 20px 40px 30px;
        table {
          max-width: 100%;
          margin-left: auto;
          margin-right: auto;
          td,th {
            border: 1px solid #CCC;
            padding: 3px 5px;
            min-height: 30px;
          }
        }
      }

      .fileList {
        border-bottom: 1px solid #013f99;
        padding: 10px 40px 30px;
        .file {
          position: relative;
          background: #fff;
          padding: 0 40px 0 5px;
          &:hover {
            background: #eee;
            cursor: pointer;
          }
          span {
            display: block;
            font-size: 14px;
            color: #333;
            line-height: 24px;
            overflow: hidden;
            white-space: nowrap;
            overflow: hidden;
          }
          .el-button {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            font-size: 20px;
            line-height: 100%;
            font-weight: 600;
            padding: 0 8px;
          }
          & + .file {
            margin-top: 10px;
          }
        }
      }
    }
    .ctrl {
      padding: 30px 0 0;
      text-align: center;
      font-size: 16px;
      color: #000000;
      span {
        cursor: pointer;
      }
    }
  }
}
@media print {
  @page {
    size: A4;
    margin: 0;
  }
  body {
    margin: 0;
    padding: 0;
  }
  img {
    max-width: 100%;
    height: auto;
  }
}
</style>
